class MessageFactory {
    createRequest = (actionType, token, data = null) => {
        const result = {
            v: '1.0.1',
            T: Date.now(),
            t: token,
            a: actionType,
            p: data ?? token,
        };

        return result;
    };

    serialize = (msg) => {
        return JSON.stringify(msg);
    };
}

const messageFactory = new MessageFactory();
export default messageFactory;
